// import { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { Button } from "./../../components/ui/button";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
//   CardDescription,
// } from "./../../components/ui/card";
// import { Badge } from "./../../components/ui/badge";
// import {
//   Tabs,
//   TabsContent,
//   TabsList,
//   TabsTrigger,
// } from "./../../components/ui/tabs";
// import { Alert, AlertDescription } from "./../../components/ui/alert";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
//   DialogDescription,
// } from "./../../components/ui/dialog";
// import { Input } from "./../../components/ui/input";
// import { Label } from "./../../components/ui/label";
// import Loader from "./../../components/ui/Loader";
// import {
//   Loader2,
//   CheckCircle,
//   XCircle,
//   UserPlus,
//   Users,
//   Briefcase,
//   Clock,
//   FileText,
//   PenTool,
//   Heart,
//   MessageCircle,
//   Eye,
//   MapPin,
//   Building,
//   Calendar,
//   ChevronRight,
//   TrendingUp,
//   BarChart3,
//   Sparkles,
//   ShieldCheck,
//   Trash,
//   AlertTriangle,
// } from "lucide-react";
// import api from "./../../api/client";
// import AnimatedBackground from "../../components/ui/AnimatedBackground";

// export default function AdminDashboard() {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("recruiters");
//   const [analytics, setAnalytics] = useState({});
//   const [blogAnalytics, setBlogAnalytics] = useState({});
//   const [recruiters, setRecruiters] = useState([]);
//   const [pendingRecruiters, setPendingRecruiters] = useState([]);
//   const [approvedJobs, setApprovedJobs] = useState([]);
//   const [pendingJobs, setPendingJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({});
//   const [success, setSuccess] = useState("");
//   const [error, setError] = useState("");
//   const [selectedRecruiter, setSelectedRecruiter] = useState(null);

//   const [open, setOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     name: "",
//     companyName: "",
//     about: "",
//     location: "",
//   });
//   const [creating, setCreating] = useState(false);

//   const [showRejectModal, setShowRejectModal] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [rejectingUserId, setRejectingUserId] = useState(null);

//   useEffect(() => {
//     if (success) setTimeout(() => setSuccess(""), 3000);
//     if (error) setTimeout(() => setError(""), 5000);
//   }, [success, error]);

//   useEffect(() => {
//     fetchData();
//     fetchPendingRecruiters();
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const [analyticsRes, recruitersRes, approvedRes, pendingRes, blogRes] =
//         await Promise.all([
//           api.get("/admin/analytics"),
//           api.get("/admin/recruiters"),
//           api.get("/admin/jobs/approved"),
//           api.get("/admin/jobs/pending"),
//           api.get("/blogs/analytics/stats"),
//         ]);
//       setAnalytics(analyticsRes.data);

//       setRecruiters(
//         // Only show users that are actual recruiters and approved by admin
//         recruitersRes.data
//           .filter(
//             (r) =>
//               r.role === "RECRUITER" &&
//               (r.recruiterProfile?.isApproved === 1 ||
//                 r.recruiterProfile?.status === "APPROVED" ||
//                 r.recruiter_status === "APPROVED"),
//           )
//           .map((recruiter) => ({
//             ...recruiter,
//             companyName:
//               recruiter.recruiterProfile?.companyName ||
//               recruiter.companyName ||
//               "Not specified",
//           })),
//       );

//       // FIX: Correct pending filter (status must be PENDING)
//       setPendingRecruiters(
//         recruitersRes.data
//           .filter(
//             (r) =>
//               r.recruiterProfile && r.recruiterProfile.status === "PENDING",
//           )
//           .map((recruiter) => ({
//             ...recruiter,
//             companyName:
//               recruiter.recruiterProfile?.companyName ||
//               recruiter.companyName ||
//               "Not specified",
//           })),
//       );

//       setApprovedJobs(approvedRes.data.jobs || []);
//       setPendingJobs(pendingRes.data || []);
//       setBlogAnalytics(blogRes.data || {});
//     } catch (err) {
//       console.error("Dashboard fetch error:", err);
//       setError("Failed to load dashboard");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPendingRecruiters = async () => {
//     try {
//       const { data } = await api.get("/admin/recruiters/pending");
//       setPendingRecruiters(data.recruiters || []);
//     } catch (err) {
//       console.error("Failed to fetch pending recruiters", err);
//     }
//   };

//   const handleCreateRecruiter = async (e) => {
//     e.preventDefault();
//     setCreating(true);
//     try {
//       await api.post("/admin/create-recruiter", formData);
//       setSuccess("Recruiter created successfully!");
//       setFormData({
//         email: "",
//         password: "",
//         name: "",
//         companyName: "",
//         about: "",
//         location: "",
//       });
//       setOpen(false);
//       fetchData();
//     } catch (err) {
//       const msg = err.response?.data?.message;
//       setError(
//         typeof msg === "object"
//           ? Object.entries(msg)
//               .map(([k, v]) => `${k}: ${v}`)
//               .join(" | ")
//           : msg || "Failed to create recruiter",
//       );
//     } finally {
//       setCreating(false);
//     }
//   };

//   const handleApproveJob = async (jobId) => {
//     setActionLoading((prev) => ({ ...prev, [jobId]: "approving" }));
//     try {
//       await api.post(`/admin/jobs/${jobId}/approve`);
//       setSuccess("Job approved successfully!");
//       fetchData();
//     } catch (err) {
//       setError("Failed to approve job");
//     } finally {
//       setActionLoading((prev) => ({ ...prev, [jobId]: null }));
//     }
//   };

//   const handleRejectJob = async (jobId) => {
//     setActionLoading((prev) => ({ ...prev, [jobId]: "rejecting" }));
//     try {
//       await api.patch(`/admin/jobs/${jobId}/reject`);
//       setSuccess("Job rejected!");
//       fetchData();
//     } catch (err) {
//       setError("Failed to reject job");
//     } finally {
//       setActionLoading((prev) => ({ ...prev, [jobId]: null }));
//     }
//   };

//   const handleApproveRecruiter = async (userId) => {
//     if (!window.confirm("Approve this recruiter?")) return;
//     setActionLoading((s) => ({ ...s, [userId]: true }));
//     try {
//       await api.post(`/admin/recruiters/${userId}/approve`);
//       setSuccess("Recruiter approved");
//       fetchPendingRecruiters();
//       // refresh recruiters list
//       await recruiters();
//     } catch (err) {
//       console.error(err);
//       setError("Failed to approve recruiter");
//     } finally {
//       setActionLoading((s) => ({ ...s, [userId]: false }));
//     }
//   };

//   const handleRejectRecruiter = async (userId) => {
//     if (
//       !window.confirm(
//         "Reject and remove this recruiter? This will delete the user.",
//       )
//     )
//       return;

//     setActionLoading((s) => ({ ...s, [userId]: true }));
//     try {
//       await api.post(`/admin/recruiters/${userId}/reject`);
//       setSuccess("Recruiter rejected and removed");
//       fetchPendingRecruiters();
//     } catch (err) {
//       console.error(err);
//       setError("Failed to reject recruiter");
//     } finally {
//       setActionLoading((s) => ({ ...s, [userId]: false }));
//     }
//   };

//   const getStatusBadge = (status, isApproved) => {
//     if (status === "PENDING") {
//       return (
//         <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-amber-500/10 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800 flex items-center gap-1.5">
//           <Clock className="w-3 h-3" />
//           Pending
//         </span>
//       );
//     } else if (isApproved) {
//       return (
//         <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-gradient-to-r from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800 flex items-center gap-1.5">
//           <ShieldCheck className="w-3 h-3" />
//           Verified
//         </span>
//       );
//     } else {
//       return (
//         <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-blue-500/10 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800 flex items-center gap-1.5">
//           <CheckCircle className="w-3 h-3" />
//           Approved
//         </span>
//       );
//     }
//   };

//   if (loading) return <Loader />;

//   return (
//     <div className="min-h-screen bg-background py-6 sm:py-8 lg:py-10">
//       <AnimatedBackground />
//       <div className="max-w-7xl mx-auto px-3 sm:px-5 lg:px-8">
//         <div className="mb-8 sm:mb-10 lg:mb-12">
//           <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 sm:gap-6">
//             <div className="space-y-3">
//               <div className="flex items-center gap-3">
//                 <div className="p-2.5 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 shadow-lg">
//                   <BarChart3 className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
//                 </div>
//                 <div>
//                   <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
//                     Admin Dashboard
//                   </h1>
//                   <p className="text-muted-foreground dark:text-gray-300 mt-1 text-sm sm:text-base">
//                     Manage recruiters, job approvals, and content analytics
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="flex flex-wrap gap-2 sm:gap-3">
//               <Button
//                 variant="premium"
//                 className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl"
//                 onClick={() => navigate("/admin/jobs/new")}
//               >
//                 <Briefcase className="w-4 h-4 mr-2" />
//                 <span className="hidden sm:inline">Post Job</span>
//                 <span className="sm:hidden">Job</span>
//               </Button>

//               <Button
//                 variant="premium"
//                 className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl from-fuchsia-500 to-pink-600"
//                 onClick={() => navigate("/admin/blog/new")}
//               >
//                 <PenTool className="w-4 h-4 mr-2" />
//                 <span className="hidden sm:inline">Post Blog</span>
//                 <span className="sm:hidden">Blog</span>
//               </Button>

//               <Dialog open={open} onOpenChange={setOpen}>
//                 <DialogTrigger asChild>
//                   <Button
//                     variant="premium"
//                     className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl from-indigo-500 to-blue-600"
//                   >
//                     <UserPlus className="w-4 h-4 mr-2" />
//                     <span className="hidden sm:inline">Create Recruiter</span>
//                     <span className="sm:hidden">Recruiter</span>
//                   </Button>
//                 </DialogTrigger>
//                 <DialogContent className="sm:max-w-md lg:max-w-lg max-h-[90vh] overflow-y-auto bg-card border-border">
//                   <DialogHeader>
//                     <DialogTitle className="text-xl font-bold text-foreground">
//                       Create New Recruiter
//                     </DialogTitle>
//                     <DialogDescription className="text-muted-foreground">
//                       Add a new recruiter to the platform
//                     </DialogDescription>
//                   </DialogHeader>

//                   <form
//                     onSubmit={handleCreateRecruiter}
//                     className="space-y-5 mt-4"
//                   >
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                       {[
//                         "name",
//                         "email",
//                         "password",
//                         "companyName",
//                         "location",
//                         "about",
//                       ].map((field) => (
//                         <div
//                           key={field}
//                           className={field === "about" ? "col-span-full" : ""}
//                         >
//                           <Label
//                             htmlFor={field}
//                             className="text-sm font-medium text-foreground mb-2 block"
//                           >
//                             {field === "companyName"
//                               ? "Company Name"
//                               : field.charAt(0).toUpperCase() + field.slice(1)}
//                           </Label>
//                           {field === "about" ? (
//                             <textarea
//                               id={field}
//                               value={formData[field]}
//                               onChange={(e) =>
//                                 setFormData({
//                                   ...formData,
//                                   [field]: e.target.value,
//                                 })
//                               }
//                               required={field !== "about"}
//                               placeholder="Enter company description"
//                               className="w-full h-24 px-4 py-3 text-sm border border-input rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent text-foreground resize-none bg-background"
//                             />
//                           ) : (
//                             <Input
//                               id={field}
//                               type={field === "password" ? "password" : "text"}
//                               value={formData[field]}
//                               onChange={(e) =>
//                                 setFormData({
//                                   ...formData,
//                                   [field]: e.target.value,
//                                 })
//                               }
//                               required={field !== "about"}
//                               placeholder={
//                                 field === "email"
//                                   ? "recruiter@company.com"
//                                   : `Enter ${field}`
//                               }
//                               className="h-11 text-sm bg-background"
//                             />
//                           )}
//                         </div>
//                       ))}
//                     </div>

//                     <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4">
//                       <Button
//                         type="button"
//                         variant="outline"
//                         onClick={() => setOpen(false)}
//                         className="h-11 px-5 text-sm rounded-xl order-2 sm:order-1"
//                       >
//                         Cancel
//                       </Button>
//                       <Button
//                         type="submit"
//                         className="h-11 px-5 text-sm rounded-xl order-1 sm:order-2"
//                         disabled={creating}
//                       >
//                         {creating ? (
//                           <>
//                             <Loader2 className="w-4 h-4 animate-spin mr-2" />
//                             Creating...
//                           </>
//                         ) : (
//                           "Create Recruiter"
//                         )}
//                       </Button>
//                     </div>
//                   </form>
//                 </DialogContent>
//               </Dialog>
//             </div>
//           </div>
//         </div>

//         <div className="mb-4 sm:mb-6 lg:mb-8 space-y-3 px-1 sm:px-0">
//           {success && (
//             <Alert className="border-emerald-200 dark:border-emerald-800 bg-gradient-to-r from-emerald-50 to-emerald-100/50 dark:from-emerald-900/20 dark:to-emerald-900/10 rounded-xl sm:rounded-2xl">
//               <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 dark:text-emerald-400" />
//               <AlertDescription className="ml-2 sm:ml-3 text-emerald-800 dark:text-emerald-300 font-medium text-xs sm:text-sm">
//                 {success}
//               </AlertDescription>
//             </Alert>
//           )}
//           {error && (
//             <Alert variant="destructive" className="rounded-xl sm:rounded-2xl">
//               <XCircle className="w-4 h-4 sm:w-5 sm:h-5" />
//               <AlertDescription className="ml-2 sm:ml-3 font-medium text-xs sm:text-sm">
//                 {error}
//               </AlertDescription>
//             </Alert>
//           )}
//         </div>

//         <div className="mb-6 sm:mb-10 lg:mb-12 px-1 sm:px-0">
//           <h2 className="text-base sm:text-lg font-bold text-foreground dark:text-white mb-4 flex items-center gap-2">
//             <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-500" />
//             Platform Overview
//           </h2>
//           <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-5">
//             <Link
//               to="/admin/user-analytics"
//               className="col-span-1 transform transition-transform hover:scale-[1.02]"
//             >
//               <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-indigo-500/20">
//                 <CardContent className="p-3.5 sm:p-5">
//                   <div className="flex items-center justify-between gap-2">
//                     <div className="min-w-0">
//                       <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
//                         Users
//                       </p>
//                       <div className="text-lg sm:text-2xl font-black text-foreground">
//                         {analytics.normalUsers || 0}
//                       </div>
//                     </div>
//                     <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-indigo-500/10 ">
//                       <Users className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-600 dark:text-indigo-400" />
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Link>

//             <Link
//               to="/admin/recruiter-analytics"
//               className="col-span-1 transform transition-transform hover:scale-[1.02]"
//             >
//               <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-emerald-500/20">
//                 <CardContent className="p-3.5 sm:p-5">
//                   <div className="flex items-center justify-between gap-2">
//                     <div className="min-w-0">
//                       <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
//                         Recruiters
//                       </p>
//                       <div className="text-lg sm:text-2xl font-black text-foreground">
//                         {analytics.recruiters || 0}
//                       </div>
//                     </div>
//                     <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-emerald-500/10 ">
//                       <Briefcase className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 dark:text-emerald-400" />
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Link>

//             <Link
//               to="/admin/jobs/approved"
//               className="col-span-1 transform transition-transform hover:scale-[1.02]"
//             >
//               <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-blue-500/20">
//                 <CardContent className="p-3.5 sm:p-5">
//                   <div className="flex items-center justify-between gap-2">
//                     <div className="min-w-0">
//                       <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
//                         Jobs
//                       </p>
//                       <div className="text-lg sm:text-2xl font-black text-foreground">
//                         {analytics.approvedJobs || 0}
//                       </div>
//                     </div>
//                     <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-blue-500/10 ">
//                       <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 dark:text-blue-400" />
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Link>

//             <Link
//               to="/admin/blog-analytics"
//               className="col-span-2 lg:col-span-2 transform transition-transform hover:scale-[1.01]"
//             >
//               <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 bg-gradient-to-br from-white via-white to-purple-50/50 dark:from-gray-800 dark:via-gray-800 dark:to-purple-900/10 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-purple-500/20">
//                 <CardContent className="p-3.5 sm:p-5">
//                   <div className="flex items-center justify-between mb-3 border-b border-gray-100 dark:border-gray-700 pb-2">
//                     <div>
//                       <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1">
//                         Blogs
//                       </p>
//                       <div className="text-lg sm:text-2xl font-black text-foreground">
//                         {blogAnalytics.totalBlogs || 0}
//                       </div>
//                     </div>
//                     <div className="p-2 rounded-lg bg-gradient-to-r from-purple-500/10 to-pink-500/10">
//                       <PenTool className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600 dark:text-purple-400" />
//                     </div>
//                   </div>
//                   <div className="grid grid-cols-2 gap-2 sm:gap-3">
//                     <div className="bg-rose-500/10 rounded-lg p-2 sm:p-2.5 flex items-center justify-between">
//                       <div>
//                         <p className="text-[10px] text-muted-foreground font-medium">
//                           Likes
//                         </p>
//                         <span className="text-xs sm:text-sm font-bold text-rose-600">
//                           {blogAnalytics.totalLikes || 0}
//                         </span>
//                       </div>
//                       <Heart className="w-3.5 h-3.5 text-rose-500" />
//                     </div>
//                     <div className="bg-blue-500/10 rounded-lg p-2 sm:p-2.5 flex items-center justify-between">
//                       <div>
//                         <p className="text-[10px] text-muted-foreground font-medium">
//                           Comments
//                         </p>
//                         <span className="text-xs sm:text-sm font-bold text-blue-600">
//                           {blogAnalytics.totalComments || 0}
//                         </span>
//                       </div>
//                       <MessageCircle className="w-3.5 h-3.5 text-blue-500" />
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Link>
//           </div>
//         </div>

//         <div className="rounded-2xl sm:rounded-3xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden mb-6 bg-card/40 backdrop-blur-md">
//           <Tabs
//             value={activeTab}
//             onValueChange={setActiveTab}
//             className="w-full"
//           >
//             <div className="px-4 sm:px-6 pt-6 pb-4 border-b border-gray-100 dark:border-gray-700">
//               <TabsList className="grid grid-cols-2 sm:grid-cols-4 gap-2 p-1 bg-muted/50 rounded-xl sm:rounded-2xl w-full">
//                 {[
//                   "recruiters",
//                   "pending-recruiters",
//                   "pending",
//                   "approved",
//                 ].map((t) => (
//                   <TabsTrigger
//                     key={t}
//                     value={t}
//                     className="text-xs sm:text-sm rounded-lg sm:rounded-xl py-2.5 sm:py-3 transition-all duration-200"
//                   >
//                     <div className="flex items-center gap-2 justify-center font-bold">
//                       {t === "recruiters" && <Users className="w-4 h-4" />}
//                       {t === "pending-recruiters" && (
//                         <UserPlus className="w-4 h-4" />
//                       )}
//                       {t === "pending" && <Clock className="w-4 h-4" />}
//                       {t === "approved" && <ShieldCheck className="w-4 h-4" />}
//                       <span className="truncate">
//                         {t === "recruiters" && "Recruiters"}
//                         {t === "pending-recruiters" && "Pending Recruiters"}
//                         {t === "pending" && "Pending Jobs"}
//                         {t === "approved" && "Approved Jobs"}
//                       </span>
//                     </div>
//                   </TabsTrigger>
//                 ))}
//               </TabsList>
//             </div>

//             <TabsContent value="recruiters" className="p-4 sm:p-6">
//               {recruiters.length === 0 ? (
//                 <div className="text-center py-20 bg-muted/10 rounded-3xl">
//                   <Briefcase className="w-12 h-12 mx-auto text-muted-foreground/30 mb-4" />
//                   <p className="font-bold">No recruiters yet</p>
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                   {recruiters.map((r) => (
//                     <Card
//                       key={r.id}
//                       className="group border-border rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-500 bg-card/50 backdrop-blur-sm"
//                     >
//                       <CardContent className="p-6">
//                         <div className="flex items-start gap-4 mb-4">
//                           <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-black shadow-lg">
//                             {r.email?.[0].toUpperCase()}
//                           </div>
//                           <div className="flex-1 min-w-0">
//                             <h4 className="font-black truncate">{r.email}</h4>
//                             <p className="text-xs font-bold text-muted-foreground truncate">
//                               {r.companyName || "No Company"}
//                             </p>
//                           </div>
//                           {getStatusBadge(
//                             r.status,
//                             r.recruiterProfile?.isApproved,
//                           )}
//                         </div>
//                         {r.recruiterProfile?.about && (
//                           <p className="text-sm text-muted-foreground line-clamp-2 italic">
//                             "{r.recruiterProfile.about}"
//                           </p>
//                         )}
//                         <div className="mt-6 flex justify-end">
//                           <Button
//                             onClick={() => setSelectedRecruiter(r)}
//                             variant="ghost"
//                             size="sm"
//                             className="font-bold hover:bg-primary/5 uppercase tracking-widest text-[10px]"
//                           >
//                             View Profile{" "}
//                             <ChevronRight className="w-4 h-4 ml-1" />
//                           </Button>
//                         </div>
//                       </CardContent>
//                     </Card>
//                   ))}
//                 </div>
//               )}
//             </TabsContent>

//             <TabsContent value="pending-recruiters" className="p-4 sm:p-6">
//               {pendingRecruiters.length === 0 ? (
//                 <div className="text-center py-20 bg-emerald-500/5 rounded-3xl text-emerald-600 font-black tracking-tight">
//                   All clear! No pending applications. ✨
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                   {pendingRecruiters.map((r) => (
//                     <Card
//                       key={r.id}
//                       className="group border-border rounded-2xl overflow-hidden shadow-xl bg-card/60 backdrop-blur-sm"
//                     >
//                       <CardContent className="p-6 space-y-4">
//                         <div className="flex items-center gap-4">
//                           <div className="w-12 h-12 rounded-2xl bg-amber-500 flex items-center justify-center text-white font-black shadow-lg">
//                             {r.email?.[0].toUpperCase()}
//                           </div>
//                           <div className="flex-1 min-w-0">
//                             <h4 className="font-black truncate">{r.email}</h4>
//                             <p className="text-xs font-bold text-amber-600 uppercase tracking-widest">
//                               PENDING REVIEW
//                             </p>
//                           </div>
//                         </div>
//                         <div className="p-4 rounded-xl bg-muted/30 border border-border">
//                           <p className="text-xs font-black text-foreground mb-1">
//                             {r.companyName}
//                           </p>
//                           {r.recruiterProfile?.location && (
//                             <p className="text-[10px] text-muted-foreground flex items-center gap-1">
//                               <MapPin className="w-3 h-3" />{" "}
//                               {r.recruiterProfile.location}
//                             </p>
//                           )}
//                         </div>
//                         <div className="grid grid-cols-2 gap-3 pt-2">
//                           <Button
//                             className="rounded-xl h-10 font-bold bg-gradient-to-r from-emerald-500 to-green-600"
//                             onClick={() => handleApproveRecruiter(r.id)}
//                             disabled={actionLoading[r.id]}
//                           >
//                             {actionLoading[r.id] === "approving-recruiter" ? (
//                               <Loader2 className="w-4 h-4 animate-spin" />
//                             ) : (
//                               <ShieldCheck className="w-4 h-4 mr-2" />
//                             )}{" "}
//                             Approve
//                           </Button>
//                           <Button
//                             variant="outline"
//                             className="rounded-xl h-10 font-bold text-destructive border-destructive/20 hover:bg-destructive/5"
//                             onClick={() => openRejectModal(r)}
//                             disabled={actionLoading[r.id]}
//                           >
//                             {actionLoading[r.id] === "rejecting-recruiter" ? (
//                               <Loader2 className="w-4 h-4 animate-spin" />
//                             ) : (
//                               <XCircle className="w-4 h-4 mr-2" />
//                             )}{" "}
//                             Reject
//                           </Button>
//                         </div>
//                       </CardContent>
//                     </Card>
//                   ))}
//                 </div>
//               )}
//             </TabsContent>

//             <TabsContent value="pending" className="p-4 sm:p-6">
//               {pendingJobs.length === 0 ? (
//                 <div className="text-center py-20 bg-muted/10 rounded-3xl font-bold">
//                   No pending jobs to review.
//                 </div>
//               ) : (
//                 <div className="space-y-4">
//                   {pendingJobs.map((job) => (
//                     <Card
//                       key={job.id}
//                       className="border-border rounded-2xl hover:bg-accent/5 transition-colors"
//                     >
//                       <CardContent className="p-6">
//                         <div className="flex flex-col sm:flex-row justify-between gap-6">
//                           <div className="flex-1 space-y-3">
//                             <h4 className="text-xl font-black">{job.title}</h4>
//                             <div className="flex flex-wrap gap-4 text-xs font-bold text-muted-foreground uppercase tracking-wider">
//                               <span className="flex items-center gap-1.5">
//                                 <Building className="w-4 h-4" />{" "}
//                                 {job.companyName || "Startup"}
//                               </span>
//                               <span className="flex items-center gap-1.5">
//                                 <MapPin className="w-4 h-4" />{" "}
//                                 {job.location || "Remote"}
//                               </span>
//                               <span className="flex items-center gap-1.5">
//                                 <Calendar className="w-4 h-4" />{" "}
//                                 {new Date(job.createdAt).toLocaleDateString()}
//                               </span>
//                             </div>
//                           </div>
//                           <div className="flex flex-wrap items-center gap-3 shrink-0">
//                             <Button
//                               variant="outline"
//                               className="rounded-xl font-black text-destructive border-destructive/20"
//                               onClick={() => handleRejectJob(job.id)}
//                               disabled={actionLoading[job.id]}
//                             >
//                               Reject
//                             </Button>
//                             <Button
//                               className="rounded-xl font-black bg-emerald-600 px-8"
//                               onClick={() => handleApproveJob(job.id)}
//                               disabled={actionLoading[job.id]}
//                             >
//                               Approve Job
//                             </Button>
//                           </div>
//                         </div>
//                       </CardContent>
//                     </Card>
//                   ))}
//                 </div>
//               )}
//             </TabsContent>

//             <TabsContent value="approved" className="p-4 sm:p-6">
//               {approvedJobs.length === 0 ? (
//                 <div className="text-center py-20 bg-muted/10 rounded-3xl font-bold">
//                   No active jobs yet.
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                   {approvedJobs.map((job) => (
//                     <Card
//                       key={job.id}
//                       className="border-border rounded-2xl hover:shadow-xl transition-all flex flex-col"
//                     >
//                       <CardContent className="p-6 flex-1 flex flex-col">
//                         <div className="flex justify-between items-start gap-4 mb-4">
//                           <h4 className="text-lg font-black leading-tight line-clamp-2">
//                             {job.title}
//                           </h4>
//                           {getStatusBadge("APPROVED", true)}
//                         </div>
//                         <div className="space-y-2 mb-6">
//                           <p className="text-sm font-bold text-indigo-600">
//                             {job.companyName || job.recruiter?.companyName}
//                           </p>
//                           <p className="text-xs text-muted-foreground flex items-center gap-1.5">
//                             <MapPin className="w-3.5 h-3.5" /> {job.location}
//                           </p>
//                         </div>
//                         <div className="mt-auto pt-4 border-t border-border/50 flex justify-between items-center text-xs font-bold text-muted-foreground italic">
//                           <span>Ref: {job.id.slice(0, 8)}</span>
//                           <Button
//                             size="sm"
//                             variant="ghost"
//                             className="font-black text-primary hover:bg-primary/5 uppercase tracking-tighter"
//                             onClick={() => navigate(`/admin/jobs/${job.id}`)}
//                           >
//                             View Dashboard{" "}
//                             <ChevronRight className="w-4 h-4 ml-1" />
//                           </Button>
//                         </div>
//                       </CardContent>
//                     </Card>
//                   ))}
//                 </div>
//               )}
//             </TabsContent>
//           </Tabs>
//         </div>
//       </div>

//       {/* Recruiter Profile Dialog */}
//       <Dialog
//         open={!!selectedRecruiter}
//         onOpenChange={(open) => !open && setSelectedRecruiter(null)}
//       >
//         <DialogContent className="sm:max-w-md rounded-3xl bg-card/95 backdrop-blur-3xl border-border/50">
//           <DialogHeader className="text-center pb-2">
//             <div className="mx-auto w-20 h-20 rounded-[2rem] bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white text-3xl font-black shadow-2xl mb-4">
//               {selectedRecruiter?.email?.[0]?.toUpperCase()}
//             </div>
//             <DialogTitle className="text-2xl font-black">
//               {selectedRecruiter?.recruiterProfile?.companyName ||
//                 "No Company Name"}
//             </DialogTitle>
//             <DialogDescription className="font-medium text-muted-foreground">
//               {selectedRecruiter?.email}
//             </DialogDescription>
//           </DialogHeader>

//           <div className="space-y-6 pt-2">
//             <div className="p-4 rounded-2xl bg-muted/40 border border-border/50 space-y-3">
//               {selectedRecruiter?.recruiterProfile?.website && (
//                 <div className="flex items-center gap-3">
//                   <div className="p-2 rounded-lg bg-indigo-500/10 text-indigo-600">
//                     <Building className="w-4 h-4" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-[10px] uppercase font-black text-muted-foreground/70">
//                       Website
//                     </p>
//                     <a
//                       href={selectedRecruiter.recruiterProfile.website}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-sm font-bold text-primary hover:underline truncate block"
//                     >
//                       {selectedRecruiter.recruiterProfile.website.replace(
//                         /^https?:\/\//,
//                         "",
//                       )}
//                     </a>
//                   </div>
//                 </div>
//               )}

//               {selectedRecruiter?.recruiterProfile?.location && (
//                 <div className="flex items-center gap-3">
//                   <div className="p-2 rounded-lg bg-emerald-500/10 text-emerald-600">
//                     <MapPin className="w-4 h-4" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-[10px] uppercase font-black text-muted-foreground/70">
//                       Location
//                     </p>
//                     <p className="text-sm font-bold text-foreground">
//                       {selectedRecruiter.recruiterProfile.location}
//                     </p>
//                   </div>
//                 </div>
//               )}

//               <div className="flex items-center gap-3">
//                 <div className="p-2 rounded-lg bg-amber-500/10 text-amber-600">
//                   <ShieldCheck className="w-4 h-4" />
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <p className="text-[10px] uppercase font-black text-muted-foreground/70">
//                     Status
//                   </p>
//                   <div className="mt-1">
//                     {getStatusBadge(
//                       selectedRecruiter?.status,
//                       selectedRecruiter?.recruiterProfile?.isApproved,
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {selectedRecruiter?.recruiterProfile?.about && (
//               <div className="relative">
//                 <div className="absolute -left-2 top-0 bottom-0 w-1 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full opacity-50"></div>
//                 <div className="pl-4">
//                   <p className="text-[10px] uppercase font-black text-muted-foreground/70 mb-1">
//                     About Company
//                   </p>
//                   <p className="text-sm font-medium text-foreground/80 leading-relaxed italic">
//                     "{selectedRecruiter.recruiterProfile.about}"
//                   </p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </DialogContent>
//       </Dialog>

//       {/* SICK Reject Modal */}
//       {showRejectModal && selectedRecruiter && (
//         <div
//           className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
//           role="dialog"
//           aria-modal="true"
//         >
//           <div className="w-full max-w-2xl mx-auto transform overflow-hidden rounded-2xl bg-gradient-to-b from-neutral-900 to-neutral-800 border border-neutral-700 shadow-2xl transition-all">
//             <div className="flex items-center gap-4 p-6 bg-gradient-to-r from-rose-600 via-pink-600 to-amber-500">
//               <div className="flex items-center justify-center w-14 h-14 rounded-full bg-white/10">
//                 <XCircle className="w-7 h-7 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-white text-xl font-extrabold">
//                   Reject Recruiter
//                 </h3>
//                 <p className="mt-1 text-white/80 text-sm">
//                   This will permanently remove the recruiter and their application.
//                 </p>
//               </div>
//             </div>

//             <div className="p-6 space-y-4">
//               <div className="flex items-start gap-4">
//                 <div className="flex-1">
//                   <p className="text-sm text-white/80">
//                     Are you sure you want to reject{" "}
//                     <span className="font-semibold text-white">
//                       {selectedRecruiter.name ||
//                         selectedRecruiter.companyName ||
//                         selectedRecruiter.email}
//                     </span>
//                     ? This action cannot be undone.
//                   </p>
//                 </div>
//                 <div className="text-right">
//                   <span className="inline-flex items-center gap-2 rounded-full bg-rose-50/20 px-3 py-1 text-rose-300 text-xs font-semibold">
//                     <AlertTriangle className="w-3 h-3" /> Permanent
//                   </span>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm text-white/80 mb-2">
//                   Reason (optional)
//                 </label>
//                 <textarea
//                   value={rejectReason}
//                   onChange={(e) => setRejectReason(e.target.value)}
//                   placeholder="Optional note to explain the rejection (this will be logged)."
//                   className="w-full min-h-[90px] resize-y rounded-lg bg-black/40 border border-neutral-700 text-white placeholder:text-white/60 p-3 focus:outline-none focus:ring-2 focus:ring-rose-500"
//                 />
//                 <p className="mt-2 text-xs text-white/60">
//                   You can provide a reason to keep an audit trail. Not required.
//                 </p>
//               </div>

//               <div className="flex items-center justify-between gap-3">
//                 <button
//                   onClick={closeRejectModal}
//                   className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white/6 text-white/90 hover:bg-white/10 transition"
//                 >
//                   Cancel
//                 </button>

//                 <div className="flex items-center gap-3">
//                   <button
//                     onClick={() => {
//                       setRejectReason("");
//                     }}
//                     className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white/6 text-white/90 hover:bg-white/10 transition"
//                   >
//                     Clear
//                   </button>

//                   <button
//                     onClick={confirmRejectRecruiter}
//                     disabled={actionLoading[rejectingUserId] === "rejecting"}
//                     className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-gradient-to-r from-rose-600 to-pink-600 text-white font-bold hover:scale-[1.01] active:scale-100 transition-transform shadow-lg"
//                   >
//                     {actionLoading[rejectingUserId] === "rejecting" ? (
//                       <svg
//                         className="w-4 h-4 animate-spin text-white"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         ></circle>
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                         ></path>
//                       </svg>
//                     ) : (
//                       <Trash className="w-4 h-4" />
//                     )}
//                     Reject & Remove
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "./../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "./../../components/ui/card";
import { Badge } from "./../../components/ui/badge";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "./../../components/ui/tabs";
import { Alert, AlertDescription } from "./../../components/ui/alert";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "./../../components/ui/dialog";
import { Input } from "./../../components/ui/input";
import { Label } from "./../../components/ui/label";
import Loader from "./../../components/ui/Loader";
import {
  Loader2,
  CheckCircle,
  XCircle,
  UserPlus,
  Users,
  Briefcase,
  Clock,
  FileText,
  PenTool,
  Heart,
  MessageCircle,
  Eye,
  MapPin,
  Building,
  Calendar,
  ChevronRight,
  TrendingUp,
  BarChart3,
  Sparkles,
  ShieldCheck,
  Trash,
  AlertTriangle,
  ThumbsUp,
  Info,
  Mail,
  Globe,
  User,
  Check,
  X,
} from "lucide-react";
import api from "./../../api/client";
import AnimatedBackground from "../../components/ui/AnimatedBackground";

export default function AdminDashboard() {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("recruiters");
  const [analytics, setAnalytics] = useState({});
  const [blogAnalytics, setBlogAnalytics] = useState({});
  const [recruiters, setRecruiters] = useState([]);
  const [pendingRecruiters, setPendingRecruiters] = useState([]);
  const [approvedJobs, setApprovedJobs] = useState([]);
  const [pendingJobs, setPendingJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    companyName: "",
    about: "",
    location: "",
  });
  const [creating, setCreating] = useState(false);

  // Modal states
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectingUserId, setRejectingUserId] = useState(null);
  const [approvingUserId, setApprovingUserId] = useState(null);

  useEffect(() => {
    if (success) setTimeout(() => setSuccess(""), 3000);
    if (error) setTimeout(() => setError(""), 5000);
  }, [success, error]);

  useEffect(() => {
    fetchData();
    fetchPendingRecruiters();
  }, []);

// In AdminDashboard.jsx, update the fetchData function
// In AdminDashboard.jsx, keep your original fetchData but fix filtering:
const fetchData = async () => {
  setLoading(true);
  setError("");
  
  try {
    console.log("=== FETCHING DASHBOARD DATA ===");
    
    const [analyticsRes, recruitersRes, pendingRecruitersRes, approvedRes, pendingRes, blogRes] =
      await Promise.all([
        api.get("/admin/analytics"),
        api.get("/admin/recruiters"), // ALL recruiters (approved + pending)
        api.get("/admin/recruiters/pending"), // Only pending
        api.get("/admin/jobs/approved"),
        api.get("/admin/jobs/pending"),
        api.get("/blogs/analytics/stats"),
      ]);
    
    console.log("✅ API calls completed");
    
    // Set analytics
    setAnalytics(analyticsRes.data);
    
    // Handle ALL recruiters (for the "Recruiters" tab)
    let allRecruiters = [];
    if (Array.isArray(recruitersRes.data)) {
      allRecruiters = recruitersRes.data;
    }
    
    console.log(`✅ ${allRecruiters.length} total recruiters (approved + pending)`);
    setRecruiters(allRecruiters);
    
    // Handle PENDING recruiters (for the "Pending Recruiters" tab)
    let pendingRecruitersData = [];
    if (pendingRecruitersRes.data?.recruiters) {
      pendingRecruitersData = pendingRecruitersRes.data.recruiters;
    } else if (Array.isArray(pendingRecruitersRes.data)) {
      pendingRecruitersData = pendingRecruitersRes.data;
    }
    
    console.log(`📋 ${pendingRecruitersData.length} PENDING recruiter applications`);
    setPendingRecruiters(pendingRecruitersData);
    
    // Process jobs
    const approvedJobs = approvedRes.data?.jobs || approvedRes.data || [];
    const pendingJobs = pendingRes.data || [];
    
    setApprovedJobs(Array.isArray(approvedJobs) ? approvedJobs : []);
    setPendingJobs(Array.isArray(pendingJobs) ? pendingJobs : []);
    
    // Set blog analytics
    setBlogAnalytics(blogRes.data || {});
    
    console.log("=== DATA FETCH COMPLETE ===");
    
  } catch (err) {
    console.error("❌ FETCH ERROR:", err);
    setError("Failed to load dashboard: " + (err.response?.data?.message || err.message));
  } finally {
    setLoading(false);
  }
};

const fetchPendingRecruiters = async () => {
  console.log("=== FETCHING PENDING RECRUITERS ===");
  
  try {
    const response = await api.get("/admin/recruiters/pending");
    console.log("Pending recruiters API response:", response.data);
    
    let pendingData = [];
    
    if (Array.isArray(response.data)) {
      pendingData = response.data;
    } else if (response.data?.recruiters) {
      pendingData = response.data.recruiters;
    } else if (response.data?.success && response.data?.recruiters) {
      pendingData = response.data.recruiters;
    } else {
      pendingData = response.data || [];
    }
    
    console.log(`✅ Fetched ${pendingData.length} pending recruiters`);
    
    // Process the data
    const formattedRecruiters = pendingData.map(r => {
      const companyName = 
        r.recruiterProfile?.companyName ||
        r.companyName ||
        "Not specified";
      
      return {
        ...r,
        companyName,
        recruiterProfile: r.recruiterProfile || {
          companyName,
          isApproved: r.isApproved || 0,
          status: r.status || "PENDING"
        }
      };
    });
    
    setPendingRecruiters(formattedRecruiters);
    
    // Also update the main recruiters list if needed
    setRecruiters(prev => {
      // Merge with existing data, updating any pending recruiters
      const updatedRecruiters = [...prev];
      formattedRecruiters.forEach(newRecruiter => {
        const index = updatedRecruiters.findIndex(r => r.id === newRecruiter.id);
        if (index > -1) {
          updatedRecruiters[index] = newRecruiter;
        } else {
          updatedRecruiters.push(newRecruiter);
        }
      });
      return updatedRecruiters;
    });
    
  } catch (err) {
    console.error("❌ PENDING RECRUITERS FETCH ERROR:", err);
    console.error("Error response:", err.response?.data);
    
    const errorMsg = err.response?.data?.message || 
                     err.response?.data?.error || 
                     err.message || 
                     "Failed to fetch pending recruiters";
    
    console.warn(`⚠️ ${errorMsg}`);
    // Don't set error state here to avoid disrupting main UI
  }
};
  const handleCreateRecruiter = async (e) => {
    e.preventDefault();
    setCreating(true);
    try {
      await api.post("/admin/create-recruiter", formData);
      setSuccess("Recruiter created successfully!");
      setFormData({
        email: "",
        password: "",
        name: "",
        companyName: "",
        about: "",
        location: "",
      });
      setOpen(false);
      fetchData();
    } catch (err) {
      const msg = err.response?.data?.message;
      setError(
        typeof msg === "object"
          ? Object.entries(msg)
              .map(([k, v]) => `${k}: ${v}`)
              .join(" | ")
          : msg || "Failed to create recruiter",
      );
    } finally {
      setCreating(false);
    }
  };

  const handleApproveJob = async (jobId) => {
    setActionLoading((prev) => ({ ...prev, [jobId]: "approving" }));
    try {
      await api.post(`/admin/jobs/${jobId}/approve`);
      setSuccess("Job approved successfully!");
      fetchData();
    } catch (err) {
      setError("Failed to approve job");
    } finally {
      setActionLoading((prev) => ({ ...prev, [jobId]: null }));
    }
  };

  const handleRejectJob = async (jobId) => {
    setActionLoading((prev) => ({ ...prev, [jobId]: "rejecting" }));
    try {
      await api.patch(`/admin/jobs/${jobId}/reject`);
      setSuccess("Job rejected!");
      fetchData();
    } catch (err) {
      setError("Failed to reject job");
    } finally {
      setActionLoading((prev) => ({ ...prev, [jobId]: null }));
    }
  };

  // Function to open approve modal
  const openApproveModal = (recruiter) => {
    setSelectedRecruiter(recruiter);
    setApprovingUserId(recruiter.id);
    setShowApproveModal(true);
  };

  // Function to open reject modal
  const openRejectModal = (recruiter) => {
    setSelectedRecruiter(recruiter);
    setRejectingUserId(recruiter.id);
    setShowRejectModal(true);
  };

  // Function to close approve modal
  const closeApproveModal = () => {
    setShowApproveModal(false);
    setSelectedRecruiter(null);
    setApprovingUserId(null);
  };

  // Function to close reject modal
  const closeRejectModal = () => {
    setShowRejectModal(false);
    setSelectedRecruiter(null);
    setRejectReason('');
    setRejectingUserId(null);
  };

  // Function to confirm approving a recruiter
  const confirmApproveRecruiter = async () => {
    if (!selectedRecruiter || !approvingUserId) return;
    
    setActionLoading(prev => ({...prev, [approvingUserId]: "approving"}));
    
    try {
      await api.post(`/admin/recruiters/${approvingUserId}/approve`);
      setSuccess("Recruiter approved successfully!");
      closeApproveModal();
      fetchPendingRecruiters();
      fetchData();
      
    } catch (err) {
      console.error(err);
      setError("Failed to approve recruiter");
    } finally {
      setActionLoading(prev => ({...prev, [approvingUserId]: null}));
    }
  };

  // Function to confirm rejecting a recruiter
  const confirmRejectRecruiter = async () => {
    if (!selectedRecruiter || !rejectingUserId) return;
    
    setActionLoading(prev => ({...prev, [rejectingUserId]: "rejecting"}));
    
    try {
      await api.post(`/admin/recruiters/${rejectingUserId}/reject`, {
        reason: rejectReason
      });
      
      setSuccess("Recruiter rejected and removed");
      closeRejectModal();
      fetchPendingRecruiters();
      fetchData();
      
    } catch (err) {
      console.error(err);
      setError("Failed to reject recruiter");
    } finally {
      setActionLoading(prev => ({...prev, [rejectingUserId]: null}));
    }
  };

  const getStatusBadge = (status, isApproved) => {
    if (status === "PENDING") {
      return (
        <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-amber-500/10 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800 flex items-center gap-1.5">
          <Clock className="w-3 h-3" />
          Pending
        </span>
      );
    } else if (isApproved) {
      return (
        <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-gradient-to-r from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800 flex items-center gap-1.5">
          <ShieldCheck className="w-3 h-3" />
          Verified
        </span>
      );
    } else {
      return (
        <span className="px-3 py-1.5 rounded-full text-xs font-medium bg-blue-500/10 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800 flex items-center gap-1.5">
          <CheckCircle className="w-3 h-3" />
          Approved
        </span>
      );
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="min-h-screen bg-background py-6 sm:py-8 lg:py-10">
      <AnimatedBackground />
      <div className="max-w-7xl mx-auto px-3 sm:px-5 lg:px-8">
        <div className="mb-8 sm:mb-10 lg:mb-12">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 sm:gap-6">
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="p-2.5 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 shadow-lg">
                  <BarChart3 className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
                </div>
                <div>
                  <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
                    Admin Dashboard
                  </h1>
                  <p className="text-muted-foreground dark:text-gray-300 mt-1 text-sm sm:text-base">
                    Manage recruiters, job approvals, and content analytics
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 sm:gap-3">
              <Button
                variant="premium"
                className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl"
                onClick={() => navigate("/admin/jobs/new")}
              >
                <Briefcase className="w-4 h-4 mr-2" />
                <span className="hidden sm:inline">Post Job</span>
                <span className="sm:hidden">Job</span>
              </Button>

              <Button
                variant="premium"
                className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl from-fuchsia-500 to-pink-600"
                onClick={() => navigate("/admin/blog/new")}
              >
                <PenTool className="w-4 h-4 mr-2" />
                <span className="hidden sm:inline">Post Blog</span>
                <span className="sm:hidden">Blog</span>
              </Button>

              <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                  <Button
                    variant="premium"
                    className="h-10 sm:h-11 px-4 sm:px-5 text-sm font-medium rounded-xl from-indigo-500 to-blue-600"
                  >
                    <UserPlus className="w-4 h-4 mr-2" />
                    <span className="hidden sm:inline">Create Recruiter</span>
                    <span className="sm:hidden">Recruiter</span>
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md lg:max-w-lg max-h-[90vh] overflow-y-auto bg-card border-border">
                  <DialogHeader>
                    <DialogTitle className="text-xl font-bold text-foreground">
                      Create New Recruiter
                    </DialogTitle>
                    <DialogDescription className="text-muted-foreground">
                      Add a new recruiter to the platform
                    </DialogDescription>
                  </DialogHeader>

                  <form
                    onSubmit={handleCreateRecruiter}
                    className="space-y-5 mt-4"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {[
                        "name",
                        "email",
                        "password",
                        "companyName",
                        "location",
                        "about",
                      ].map((field) => (
                        <div
                          key={field}
                          className={field === "about" ? "col-span-full" : ""}
                        >
                          <Label
                            htmlFor={field}
                            className="text-sm font-medium text-foreground mb-2 block"
                          >
                            {field === "companyName"
                              ? "Company Name"
                              : field.charAt(0).toUpperCase() + field.slice(1)}
                          </Label>
                          {field === "about" ? (
                            <textarea
                              id={field}
                              value={formData[field]}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  [field]: e.target.value,
                                })
                              }
                              required={field !== "about"}
                              placeholder="Enter company description"
                              className="w-full h-24 px-4 py-3 text-sm border border-input rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent text-foreground resize-none bg-background"
                            />
                          ) : (
                            <Input
                              id={field}
                              type={field === "password" ? "password" : "text"}
                              value={formData[field]}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  [field]: e.target.value,
                                })
                              }
                              required={field !== "about"}
                              placeholder={
                                field === "email"
                                  ? "recruiter@company.com"
                                  : `Enter ${field}`
                              }
                              className="h-11 text-sm bg-background"
                            />
                          )}
                        </div>
                      ))}
                    </div>

                    <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4">
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() => setOpen(false)}
                        className="h-11 px-5 text-sm rounded-xl order-2 sm:order-1"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="h-11 px-5 text-sm rounded-xl order-1 sm:order-2"
                        disabled={creating}
                      >
                        {creating ? (
                          <>
                            <Loader2 className="w-4 h-4 animate-spin mr-2" />
                            Creating...
                          </>
                        ) : (
                          "Create Recruiter"
                        )}
                      </Button>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>

        <div className="mb-4 sm:mb-6 lg:mb-8 space-y-3 px-1 sm:px-0">
          {success && (
            <Alert className="border-emerald-200 dark:border-emerald-800 bg-gradient-to-r from-emerald-50 to-emerald-100/50 dark:from-emerald-900/20 dark:to-emerald-900/10 rounded-xl sm:rounded-2xl">
              <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 dark:text-emerald-400" />
              <AlertDescription className="ml-2 sm:ml-3 text-emerald-800 dark:text-emerald-300 font-medium text-xs sm:text-sm">
                {success}
              </AlertDescription>
            </Alert>
          )}
          {error && (
            <Alert variant="destructive" className="rounded-xl sm:rounded-2xl">
              <XCircle className="w-4 h-4 sm:w-5 sm:h-5" />
              <AlertDescription className="ml-2 sm:ml-3 font-medium text-xs sm:text-sm">
                {error}
              </AlertDescription>
            </Alert>
          )}
        </div>

        <div className="mb-6 sm:mb-10 lg:mb-12 px-1 sm:px-0">
          <h2 className="text-base sm:text-lg font-bold text-foreground dark:text-white mb-4 flex items-center gap-2">
            <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-500" />
            Platform Overview
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-5">
            <Link
              to="/admin/user-analytics"
              className="col-span-1 transform transition-transform hover:scale-[1.02]"
            >
              <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-indigo-500/20">
                <CardContent className="p-3.5 sm:p-5">
                  <div className="flex items-center justify-between gap-2">
                    <div className="min-w-0">
                      <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
                        Users
                      </p>
                      <div className="text-lg sm:text-2xl font-black text-foreground">
                        {analytics.normalUsers || 0}
                      </div>
                    </div>
                    <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-indigo-500/10 ">
                      <Users className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-600 dark:text-indigo-400" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link
              to="/admin/recruiter-analytics"
              className="col-span-1 transform transition-transform hover:scale-[1.02]"
            >
              <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-emerald-500/20">
                <CardContent className="p-3.5 sm:p-5">
                  <div className="flex items-center justify-between gap-2">
                    <div className="min-w-0">
                      <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
                        Recruiters
                      </p>
                      <div className="text-lg sm:text-2xl font-black text-foreground">
                        {analytics.recruiters || 0}
                      </div>
                    </div>
                    <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-emerald-500/10 ">
                      <Briefcase className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 dark:text-emerald-400" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link
              to="/admin/jobs/approved"
              className="col-span-1 transform transition-transform hover:scale-[1.02]"
            >
              <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-blue-500/20">
                <CardContent className="p-3.5 sm:p-5">
                  <div className="flex items-center justify-between gap-2">
                    <div className="min-w-0">
                      <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1 truncate">
                        Jobs
                      </p>
                      <div className="text-lg sm:text-2xl font-black text-foreground">
                        {analytics.approvedJobs || 0}
                      </div>
                    </div>
                    <div className="flex-shrink-0 p-2 sm:p-2.5 rounded-lg sm:rounded-xl bg-blue-500/10 ">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 dark:text-blue-400" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link
              to="/admin/blog-analytics"
              className="col-span-2 lg:col-span-2 transform transition-transform hover:scale-[1.01]"
            >
              <Card className="h-full border-0 shadow-sm hover:shadow-xl transition-all duration-300 bg-gradient-to-br from-white via-white to-purple-50/50 dark:from-gray-800 dark:via-gray-800 dark:to-purple-900/10 rounded-xl sm:rounded-2xl overflow-hidden border-b-2 border-purple-500/20">
                <CardContent className="p-3.5 sm:p-5">
                  <div className="flex items-center justify-between mb-3 border-b border-gray-100 dark:border-gray-700 pb-2">
                    <div>
                      <p className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1">
                        Blogs
                      </p>
                      <div className="text-lg sm:text-2xl font-black text-foreground">
                        {blogAnalytics.totalBlogs || 0}
                      </div>
                    </div>
                    <div className="p-2 rounded-lg bg-gradient-to-r from-purple-500/10 to-pink-500/10">
                      <PenTool className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600 dark:text-purple-400" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 sm:gap-3">
                    <div className="bg-rose-500/10 rounded-lg p-2 sm:p-2.5 flex items-center justify-between">
                      <div>
                        <p className="text-[10px] text-muted-foreground font-medium">
                          Likes
                        </p>
                        <span className="text-xs sm:text-sm font-bold text-rose-600">
                          {blogAnalytics.totalLikes || 0}
                        </span>
                      </div>
                      <Heart className="w-3.5 h-3.5 text-rose-500" />
                    </div>
                    <div className="bg-blue-500/10 rounded-lg p-2 sm:p-2.5 flex items-center justify-between">
                      <div>
                        <p className="text-[10px] text-muted-foreground font-medium">
                          Comments
                        </p>
                        <span className="text-xs sm:text-sm font-bold text-blue-600">
                          {blogAnalytics.totalComments || 0}
                        </span>
                      </div>
                      <MessageCircle className="w-3.5 h-3.5 text-blue-500" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        </div>

        <div className="rounded-2xl sm:rounded-3xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden mb-6 bg-card/40 backdrop-blur-md">
          <Tabs
            value={activeTab}
            onValueChange={setActiveTab}
            className="w-full"
          >
            <div className="px-4 sm:px-6 pt-6 pb-4 border-b border-gray-100 dark:border-gray-700">
              <TabsList className="grid grid-cols-2 sm:grid-cols-4 gap-2 p-1 bg-muted/50 rounded-xl sm:rounded-2xl w-full">
                {[
                  "recruiters",
                  "pending-recruiters",
                  "pending",
                  "approved",
                ].map((t) => (
                  <TabsTrigger
                    key={t}
                    value={t}
                    className="text-xs sm:text-sm rounded-lg sm:rounded-xl py-2.5 sm:py-3 transition-all duration-200"
                  >
                    <div className="flex items-center gap-2 justify-center font-bold">
                      {t === "recruiters" && <Users className="w-4 h-4" />}
                      {t === "pending-recruiters" && (
                        <UserPlus className="w-4 h-4" />
                      )}
                      {t === "pending" && <Clock className="w-4 h-4" />}
                      {t === "approved" && <ShieldCheck className="w-4 h-4" />}
                      <span className="truncate">
                        {t === "recruiters" && "Recruiters"}
                        {t === "pending-recruiters" && "Pending Recruiters"}
                        {t === "pending" && "Pending Jobs"}
                        {t === "approved" && "Approved Jobs"}
                      </span>
                    </div>
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>

            <TabsContent value="recruiters" className="p-4 sm:p-6">
              {recruiters.length === 0 ? (
                <div className="text-center py-20 bg-muted/10 rounded-3xl">
                  <Briefcase className="w-12 h-12 mx-auto text-muted-foreground/30 mb-4" />
                  <p className="font-bold">No recruiters yet</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {recruiters.map((r) => (
                    <Card
                      key={r.id}
                      className="group border-border rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-500 bg-card/50 backdrop-blur-sm"
                    >
                      <CardContent className="p-6">
                        <div className="flex items-start gap-4 mb-4">
                          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-black shadow-lg">
                            {r.email?.[0].toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <h4 className="font-black truncate">{r.email}</h4>
                            <p className="text-xs font-bold text-muted-foreground truncate">
                              {r.companyName || "No Company"}
                            </p>
                          </div>
                          {getStatusBadge(
                            r.status,
                            r.recruiterProfile?.isApproved,
                          )}
                        </div>
                        {r.recruiterProfile?.about && (
                          <p className="text-sm text-muted-foreground line-clamp-2 italic">
                            "{r.recruiterProfile.about}"
                          </p>
                        )}
                        <div className="mt-6 flex justify-end">
                          <Button
                            onClick={() => setSelectedRecruiter(r)}
                            variant="ghost"
                            size="sm"
                            className="font-bold hover:bg-primary/5 uppercase tracking-widest text-[10px]"
                          >
                            View Profile{" "}
                            <ChevronRight className="w-4 h-4 ml-1" />
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </TabsContent>

            <TabsContent value="pending-recruiters" className="p-4 sm:p-6">
              {pendingRecruiters.length === 0 ? (
                <div className="text-center py-20 bg-emerald-500/5 rounded-3xl text-emerald-600 font-black tracking-tight">
                  All clear! No pending applications. ✨
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {pendingRecruiters.map((r) => (
                    <Card
                      key={r.id}
                      className="group border-border rounded-2xl overflow-hidden shadow-xl bg-card/60 backdrop-blur-sm"
                    >
                      <CardContent className="p-6 space-y-4">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 rounded-2xl bg-amber-500 flex items-center justify-center text-white font-black shadow-lg">
                            {r.email?.[0].toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <h4 className="font-black truncate">{r.email}</h4>
                            <p className="text-xs font-bold text-amber-600 uppercase tracking-widest">
                              PENDING REVIEW
                            </p>
                          </div>
                        </div>
                        <div className="p-4 rounded-xl bg-muted/30 border border-border">
                          <p className="text-xs font-black text-foreground mb-1">
                            {r.companyName}
                          </p>
                          {r.recruiterProfile?.location && (
                            <p className="text-[10px] text-muted-foreground flex items-center gap-1">
                              <MapPin className="w-3 h-3" />{" "}
                              {r.recruiterProfile.location}
                            </p>
                          )}
                        </div>
                        <div className="grid grid-cols-2 gap-3 pt-2">
                          <Button
                            className="rounded-xl h-10 font-bold bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700"
                            onClick={() => openApproveModal(r)}
                            disabled={actionLoading[r.id]}
                          >
                            {actionLoading[r.id] === "approving" ? (
                              <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                              <ThumbsUp className="w-4 h-4 mr-2" />
                            )}{" "}
                            Approve
                          </Button>
                          <Button
                            variant="outline"
                            className="rounded-xl h-10 font-bold text-destructive border-destructive/20 hover:bg-destructive/5 hover:border-destructive/30"
                            onClick={() => openRejectModal(r)}
                            disabled={actionLoading[r.id]}
                          >
                            {actionLoading[r.id] === "rejecting" ? (
                              <Loader2 className="w-4 h-4 animate-spin" />
                            ) : (
                              <XCircle className="w-4 h-4 mr-2" />
                            )}{" "}
                            Reject
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </TabsContent>

            <TabsContent value="pending" className="p-4 sm:p-6">
              {pendingJobs.length === 0 ? (
                <div className="text-center py-20 bg-muted/10 rounded-3xl font-bold">
                  No pending jobs to review.
                </div>
              ) : (
                <div className="space-y-4">
                  {pendingJobs.map((job) => (
                    <Card
                      key={job.id}
                      className="border-border rounded-2xl hover:bg-accent/5 transition-colors"
                    >
                      <CardContent className="p-6">
                        <div className="flex flex-col sm:flex-row justify-between gap-6">
                          <div className="flex-1 space-y-3">
                            <h4 className="text-xl font-black">{job.title}</h4>
                            <div className="flex flex-wrap gap-4 text-xs font-bold text-muted-foreground uppercase tracking-wider">
                              <span className="flex items-center gap-1.5">
                                <Building className="w-4 h-4" />{" "}
                                {job.companyName || "Startup"}
                              </span>
                              <span className="flex items-center gap-1.5">
                                <MapPin className="w-4 h-4" />{" "}
                                {job.location || "Remote"}
                              </span>
                              <span className="flex items-center gap-1.5">
                                <Calendar className="w-4 h-4" />{" "}
                                {new Date(job.createdAt).toLocaleDateString()}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-wrap items-center gap-3 shrink-0">
                            <Button
                              variant="outline"
                              className="rounded-xl font-black text-destructive border-destructive/20"
                              onClick={() => handleRejectJob(job.id)}
                              disabled={actionLoading[job.id]}
                            >
                              Reject
                            </Button>
                            <Button
                              className="rounded-xl font-black bg-emerald-600 px-8 hover:bg-emerald-700"
                              onClick={() => handleApproveJob(job.id)}
                              disabled={actionLoading[job.id]}
                            >
                              Approve Job
                            </Button>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </TabsContent>

            <TabsContent value="approved" className="p-4 sm:p-6">
              {approvedJobs.length === 0 ? (
                <div className="text-center py-20 bg-muted/10 rounded-3xl font-bold">
                  No active jobs yet.
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {approvedJobs.map((job) => (
                    <Card
                      key={job.id}
                      className="border-border rounded-2xl hover:shadow-xl transition-all flex flex-col"
                    >
                      <CardContent className="p-6 flex-1 flex flex-col">
                        <div className="flex justify-between items-start gap-4 mb-4">
                          <h4 className="text-lg font-black leading-tight line-clamp-2">
                            {job.title}
                          </h4>
                          {getStatusBadge("APPROVED", true)}
                        </div>
                        <div className="space-y-2 mb-6">
                          <p className="text-sm font-bold text-indigo-600">
                            {job.companyName || job.recruiter?.companyName}
                          </p>
                          <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                            <MapPin className="w-3.5 h-3.5" /> {job.location}
                          </p>
                        </div>
                        <div className="mt-auto pt-4 border-t border-border/50 flex justify-between items-center text-xs font-bold text-muted-foreground italic">
                          <span>Ref: {job.id.slice(0, 8)}</span>
                          <Button
                            size="sm"
                            variant="ghost"
                            className="font-black text-primary hover:bg-primary/5 uppercase tracking-tighter"
                            onClick={() => navigate(`/admin/jobs/${job.id}`)}
                          >
                            View Dashboard{" "}
                            <ChevronRight className="w-4 h-4 ml-1" />
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </TabsContent>
          </Tabs>
        </div>
      </div>

      {/* Recruiter Profile Dialog */}
      <Dialog
        open={!!selectedRecruiter && !showApproveModal && !showRejectModal}
        onOpenChange={(open) => !open && setSelectedRecruiter(null)}
      >
        <DialogContent className="sm:max-w-md rounded-3xl bg-card/95 backdrop-blur-3xl border-border/50">
          <DialogHeader className="text-center pb-2">
            <div className="mx-auto w-20 h-20 rounded-[2rem] bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white text-3xl font-black shadow-2xl mb-4">
              {selectedRecruiter?.email?.[0]?.toUpperCase()}
            </div>
            <DialogTitle className="text-2xl font-black">
              {selectedRecruiter?.recruiterProfile?.companyName ||
                "No Company Name"}
            </DialogTitle>
            <DialogDescription className="font-medium text-muted-foreground">
              {selectedRecruiter?.email}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-6 pt-2">
            <div className="p-4 rounded-2xl bg-muted/40 border border-border/50 space-y-3">
              {selectedRecruiter?.recruiterProfile?.website && (
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-indigo-500/10 text-indigo-600">
                    <Building className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[10px] uppercase font-black text-muted-foreground/70">
                      Website
                    </p>
                    <a
                      href={selectedRecruiter.recruiterProfile.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm font-bold text-primary hover:underline truncate block"
                    >
                      {selectedRecruiter.recruiterProfile.website.replace(
                        /^https?:\/\//,
                        "",
                      )}
                    </a>
                  </div>
                </div>
              )}

              {selectedRecruiter?.recruiterProfile?.location && (
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-emerald-500/10 text-emerald-600">
                    <MapPin className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[10px] uppercase font-black text-muted-foreground/70">
                      Location
                    </p>
                    <p className="text-sm font-bold text-foreground">
                      {selectedRecruiter.recruiterProfile.location}
                    </p>
                  </div>
                </div>
              )}

              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-amber-500/10 text-amber-600">
                  <ShieldCheck className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[10px] uppercase font-black text-muted-foreground/70">
                    Status
                  </p>
                  <div className="mt-1">
                    {getStatusBadge(
                      selectedRecruiter?.status,
                      selectedRecruiter?.recruiterProfile?.isApproved,
                    )}
                  </div>
                </div>
              </div>
            </div>

            {selectedRecruiter?.recruiterProfile?.about && (
              <div className="relative">
                <div className="absolute -left-2 top-0 bottom-0 w-1 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full opacity-50"></div>
                <div className="pl-4">
                  <p className="text-[10px] uppercase font-black text-muted-foreground/70 mb-1">
                    About Company
                  </p>
                  <p className="text-sm font-medium text-foreground/80 leading-relaxed italic">
                    "{selectedRecruiter.recruiterProfile.about}"
                  </p>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Approve Modal */}
      {showApproveModal && selectedRecruiter && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
          role="dialog"
          aria-modal="true"
        >
          <div className="w-full max-w-2xl mx-auto transform overflow-hidden rounded-2xl bg-gradient-to-b from-neutral-50 to-white dark:from-neutral-900 dark:to-neutral-800 border border-neutral-200 dark:border-neutral-700 shadow-2xl transition-all">
            <div className="flex items-center gap-4 p-6 bg-gradient-to-r from-emerald-500 via-green-500 to-teal-500">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-white/20">
                <CheckCircle className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-white text-xl font-extrabold">
                  Approve Recruiter
                </h3>
                <p className="mt-1 text-white/90 text-sm">
                  This will grant full platform access to the recruiter.
                </p>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Recruiter Details */}
              <div className="bg-neutral-50 dark:bg-neutral-900/50 rounded-xl p-4 border border-neutral-200 dark:border-neutral-700">
                <h4 className="font-bold text-neutral-800 dark:text-neutral-200 mb-3 flex items-center gap-2">
                  <User className="w-4 h-4" /> Recruiter Details
                </h4>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center text-white font-bold">
                      {selectedRecruiter.email?.[0]?.toUpperCase()}
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-neutral-900 dark:text-white">
                        {selectedRecruiter.email}
                      </p>
                      <p className="text-sm text-neutral-600 dark:text-neutral-400">
                        {selectedRecruiter.companyName || "No company name"}
                      </p>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    {selectedRecruiter.recruiterProfile?.location && (
                      <div className="flex items-center gap-2 text-neutral-700 dark:text-neutral-300">
                        <MapPin className="w-4 h-4 text-neutral-500" />
                        <span>{selectedRecruiter.recruiterProfile.location}</span>
                      </div>
                    )}
                    
                    {selectedRecruiter.recruiterProfile?.website && (
                      <div className="flex items-center gap-2 text-neutral-700 dark:text-neutral-300">
                        <Globe className="w-4 h-4 text-neutral-500" />
                        <a 
                          href={selectedRecruiter.recruiterProfile.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors"
                        >
                          {selectedRecruiter.recruiterProfile.website.replace(/^https?:\/\//, '')}
                        </a>
                      </div>
                    )}
                  </div>
                  
                  {selectedRecruiter.recruiterProfile?.about && (
                    <div className="mt-3 pt-3 border-t border-neutral-200 dark:border-neutral-700">
                      <p className="text-xs font-semibold text-neutral-600 dark:text-neutral-400 mb-1">About Company</p>
                      <p className="text-sm text-neutral-700 dark:text-neutral-300 italic">
                        "{selectedRecruiter.recruiterProfile.about}"
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* Confirmation Message */}
              <div className="bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 rounded-xl p-4">
                <div className="flex items-start gap-3">
                  <Info className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mt-0.5" />
                  <div>
                    <p className="font-medium text-emerald-800 dark:text-emerald-300">
                      Are you sure you want to approve this recruiter?
                    </p>
                    <p className="text-sm text-emerald-700 dark:text-emerald-400 mt-1">
                      They will be able to post jobs, manage applications, and access all recruiter features.
                    </p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex items-center justify-between gap-3 pt-4">
                <button
                  onClick={closeApproveModal}
                  className="inline-flex items-center gap-2 px-4 py-3 rounded-lg bg-neutral-200 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-300 dark:hover:bg-neutral-700 transition font-medium"
                >
                  <X className="w-4 h-4" /> Cancel
                </button>

                <button
                  onClick={confirmApproveRecruiter}
                  disabled={actionLoading[approvingUserId] === "approving"}
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-bold hover:scale-[1.02] active:scale-100 transition-transform shadow-lg disabled:opacity-70"
                >
                  {actionLoading[approvingUserId] === "approving" ? (
                    <>
                      <svg
                        className="w-4 h-4 animate-spin text-white"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      Approving...
                    </>
                  ) : (
                    <>
                      <Check className="w-4 h-4" /> Confirm Approval
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reject Modal */}
      {showRejectModal && selectedRecruiter && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
          role="dialog"
          aria-modal="true"
        >
          <div className="w-full max-w-2xl mx-auto transform overflow-hidden rounded-2xl bg-gradient-to-b from-neutral-900 to-neutral-800 border border-neutral-700 shadow-2xl transition-all">
            <div className="flex items-center gap-4 p-6 bg-gradient-to-r from-rose-600 via-pink-600 to-amber-500">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-white/10">
                <XCircle className="w-7 h-7 text-white" />
              </div>
              <div>
                <h3 className="text-white text-xl font-extrabold">
                  Reject Recruiter
                </h3>
                <p className="mt-1 text-white/80 text-sm">
                  This will permanently remove the recruiter and their application.
                </p>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Recruiter Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 border border-neutral-700">
                <h4 className="font-bold text-white mb-3 flex items-center gap-2">
                  <User className="w-4 h-4" /> Recruiter Details
                </h4>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-rose-500 to-pink-500 flex items-center justify-center text-white font-bold">
                      {selectedRecruiter.email?.[0]?.toUpperCase()}
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-white">
                        {selectedRecruiter.email}
                      </p>
                      <p className="text-sm text-neutral-400">
                        {selectedRecruiter.companyName || "No company name"}
                      </p>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    {selectedRecruiter.recruiterProfile?.location && (
                      <div className="flex items-center gap-2 text-neutral-300">
                        <MapPin className="w-4 h-4 text-neutral-500" />
                        <span>{selectedRecruiter.recruiterProfile.location}</span>
                      </div>
                    )}
                    
                    {selectedRecruiter.recruiterProfile?.website && (
                      <div className="flex items-center gap-2 text-neutral-300">
                        <Globe className="w-4 h-4 text-neutral-500" />
                        <span className="truncate">
                          {selectedRecruiter.recruiterProfile.website.replace(/^https?:\/\//, '')}
                        </span>
                      </div>
                    )}
                  </div>
                  
                  {selectedRecruiter.recruiterProfile?.about && (
                    <div className="mt-3 pt-3 border-t border-neutral-700">
                      <p className="text-xs font-semibold text-neutral-400 mb-1">About Company</p>
                      <p className="text-sm text-neutral-300 italic">
                        "{selectedRecruiter.recruiterProfile.about}"
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="flex-1">
                    <p className="text-sm text-white/80">
                      Are you sure you want to reject{" "}
                      <span className="font-semibold text-white">
                        {selectedRecruiter.name ||
                          selectedRecruiter.companyName ||
                          selectedRecruiter.email}
                      </span>
                      ? This action cannot be undone.
                    </p>
                  </div>
                  <div className="text-right">
                    <span className="inline-flex items-center gap-2 rounded-full bg-rose-50/20 px-3 py-1 text-rose-300 text-xs font-semibold">
                      <AlertTriangle className="w-3 h-3" /> Permanent
                    </span>
                  </div>
                </div>

                <div>
                  <label className="block text-sm text-white/80 mb-2">
                    Reason (optional)
                  </label>
                  <textarea
                    value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    placeholder="Optional note to explain the rejection (this will be logged)."
                    className="w-full min-h-[90px] resize-y rounded-lg bg-black/40 border border-neutral-700 text-white placeholder:text-white/60 p-3 focus:outline-none focus:ring-2 focus:ring-rose-500"
                  />
                  <p className="mt-2 text-xs text-white/60">
                    You can provide a reason to keep an audit trail. Not required.
                  </p>
                </div>

                <div className="flex items-center justify-between gap-3 pt-4">
                  <button
                    onClick={closeRejectModal}
                    className="inline-flex items-center gap-2 px-4 py-3 rounded-lg bg-white/6 text-white/90 hover:bg-white/10 transition font-medium"
                  >
                    <X className="w-4 h-4" /> Cancel
                  </button>

                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => {
                        setRejectReason("");
                      }}
                      className="inline-flex items-center gap-2 px-4 py-3 rounded-lg bg-white/6 text-white/90 hover:bg-white/10 transition font-medium"
                    >
                      Clear Reason
                    </button>

                    <button
                      onClick={confirmRejectRecruiter}
                      disabled={actionLoading[rejectingUserId] === "rejecting"}
                      className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-gradient-to-r from-rose-600 to-pink-600 text-white font-bold hover:scale-[1.02] active:scale-100 transition-transform shadow-lg disabled:opacity-70"
                    >
                      {actionLoading[rejectingUserId] === "rejecting" ? (
                        <>
                          <svg
                            className="w-4 h-4 animate-spin text-white"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                            ></path>
                          </svg>
                          Rejecting...
                        </>
                      ) : (
                        <>
                          <Trash className="w-4 h-4" /> Reject & Remove
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}